module.exports = __webpack_public_path__ + "img/ic_close_larger.86816f73.svg";